import React, { useState, useEffect } from "react";
import "./merchandiseKit.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import plus from "../../../../assets/u400c/plus.png";
import minus from "../../../../assets/u400c/minus.png";
import info from "../../../../assets/u400c/mer-info.png";
import addCartIcon from "../../../../assets/Cart_icon.png";
import removeCartIcon from "../../../..//assets/Delete_cart_icon.png";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";

import { useSelector } from "react-redux";

const MerchandiseKit = ({ item, handleInfoModal, onCart, add, countValue }) => {
  // const [counter, updateCounter] = useState(countValue);
  const [counter, updateCounter] = useState(1);
  const [chooseSize, setChooseSize] = useState("");
  const [color, setColor] = useState("");
  const [price, setPrice] = useState(0);
  const [mrp, setMrp] = useState("");
  const [discount, setDiscount] = useState("0");
  const [size, setSize] = useState("");
  const [productCode, setProductCode] = useState("");
  const [personalizeText, setPersonalizeText] = useState("");
  const [cart, setCart] = useState(false);
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [inventoryCount, setInventoryCount] = useState(0);

  const customConfigData = useSelector((state) => state.customConfigData.data);

  const dispatch = useDispatch();

  useEffect(() => {
    if (item?.counter) {
      updateCounter(item?.counter);
    }
  }, []);

  useEffect(() => {
    const defaultItem = item?.Variants?.find(
      (el) => el?.InventoryCount !== 0 && el?.Price !== "0" && el?.Quntity !== 0
    );
    const defaultItemIndex = item?.Variants?.findIndex(
      (el) => el?.InventoryCount !== 0 && el?.Price !== "0" && el?.Quntity !== 0
    );

    setChooseSize(defaultItemIndex);
    setColor(defaultItem?.Color);
    setMrp(defaultItem?.MRP);
    setPrice(defaultItem?.Price || 0);
    setDiscount(defaultItem?.DiscountPercentage);
    setSize(defaultItem?.Size);
    setProductCode(defaultItem?.ProductCode);
    setPersonalizeText(defaultItem?.PersonalizeText);
    onSizeChange(defaultItem?.ProductCode);
    setMaxQuantity(defaultItem?.Quntity);
    setInventoryCount(defaultItem?.InventoryCount);

    customConfigData?.orderDetails?.map((element) => {
      if (
        element?.ProductId === defaultItem?.ProductCode ||
        element?.ProductId === item?.ProductCode
      ) {
        setCart(true);
        updateCounter(element.Quantity);
      }
    });
  }, []);

  const handleIncrement = (partNumber, productPrice, productMrp, qty) => {
    // customConfigData?.merchandise?.map((element) => {
    //   if (element.ProductCode === partNumber) {
    //     element.countValue = element.countValue + 1;
    //   }
    // });
    // console.log(
    //   "Max Quantity @@>>>>",
    //   partNumber,
    //   productPrice,
    //   productMrp,
    //   qty
    // );

    const count = counter + 1;
    // console.log("Max Quantity>>>>", qty);

    // console.log("handle Increment", count);

    if (count <= qty) {
      updateCounter(counter + 1);

      const hasProductId = customConfigData?.orderDetails?.some(
        (item) => item.ProductId === partNumber
      );

      if (hasProductId) {
        customConfigData?.orderDetails?.map((element) => {
          if (element.ProductId === partNumber) {
            element.Quantity = element.Quantity + 1;
            element.Price =
              parseInt(element.Price) +
              parseInt(productPrice?.replace(/,/g, ""));
            element.MRP =
              parseInt(element.MRP) + parseInt(productMrp?.replace(/,/g, ""));
          }
        });
      }
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const handleDecrement = (partNumber, productPrice, productMrp) => {
    // customConfigData?.merchandise?.map((element) => {
    //   if (element.ProductCode === partNumber) {
    //     element.countValue =
    //       element.countValue === 1 ? 1 : element.countValue - 1;
    //   }
    // });
    updateCounter(counter === 1 ? 1 : counter - 1);

    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === partNumber
    );

    const count = counter === 1 ? 1 : counter - 1;
    // console.log("handleDecrement", count);

    // if (hasProductId) {
    //   customConfigData?.orderDetails?.map((element) => {
    //     if (element.ProductId === partNumber) {
    //       element.Quantity = element.Quantity === 1 ? 1 : element.Quantity - 1;
    //       element.Price =
    //         element.Price === productPrice
    //           ? productPrice
    //           : element.Price - productPrice;
    //       element.MRP =
    //         element.MRP === productMrp ? productMrp : element.MRP - productMrp;
    //     }
    //   });
    // }

    if (hasProductId) {
      customConfigData?.orderDetails?.map((element) => {
        if (element.ProductId === partNumber) {
          element.Quantity = count;
          element.Price = parseInt(productPrice?.replace(/,/g, "")) * count;
          element.MRP = parseInt(productMrp?.replace(/,/g, "")) * count;
        }
      });
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const CarouselProps = {
    showArrows: false,
    interval: 3500,
    dynamicHeight: false,
    stopOnHover: false,
    infiniteLoop: true,
    showStatus: false,
    transitionTime: 500,
    showThumbs: false,
    showIndicators: true,
    swipeable: true,
    emulateTouch: true,
  };

  const onSizeChange = (productCode) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === productCode
    );

    if (hasProductId) {
      customConfigData?.orderDetails?.map((element) => {
        if (element.ProductId === productCode) {
          setCart(true);
          updateCounter(element.Quantity);
        }
      });
    } else {
      setCart(false);
      updateCounter(1);
    }
  };
  const hasSize = item?.Variants?.some(
    (elem) =>
      item?.Variants?.length !== 0 && (elem?.Size === null || elem?.Size === "")
  );
  const parentHasSize = item?.Variants?.length !== 0;

  const CartIcon = () => {
    return (
      <div
        className="mer_cart"
        onClick={() => {
          onCart(
            item?.Name,
            price || item?.Price,
            productCode || item?.ProductCode,
            item?.Catogery,
            !cart,
            counter,
            color || item?.Color,
            personalizeText || item?.PersonalizeText || "",
            mrp || item?.MRP,
            discount,
            item?.Images[0],
            size || item?.Size
          );
          setCart(!cart);
          updateCounter(!cart === false ? 1 : counter);
        }}
      >
        <div className="mer_cart_text mediumFont">
          {cart === true ? "Remove" : "Add"}
        </div>

        <img
          src={cart === true ? removeCartIcon : addCartIcon}
          className="mer_cart_logo_img"
        ></img>
      </div>
    );
  };

  const OutOfStock = () => {
    return (
      <div className="out_of_stock">
        <div className=" out_of_stock_text boldFont">Out of stock</div>
      </div>
    );
  };

  const PriceLabel = () => {
    return (
      <div className="product_price_con">
        <div className="product_price boldFont">
          ₹{price || item?.Price}
          {(parseInt(mrp) || parseInt(item?.MRP)) >
            (parseInt(price) || parseInt(item?.Price)) && (
            <span className="mediumFont">₹{mrp || item?.MRP} </span>
          )}
          {parseInt(discount) > 0 && <span>({discount}%OFF)</span>}
        </div>
        <div className="product_price_label mediumFont">
          Price Inclusive of all taxes
        </div>
      </div>
    );
  };

  return (
    <>
      {(item?.Variants?.length === 0 && item?.InventoryCount === 0) ||
      (item?.Variants?.length > 0 && inventoryCount === 0) ||
      (item?.Variants?.length === 0 && item?.Price === 0) ||
      (item?.Variants?.length > 0 && price === 0) ||
      (item?.Variants?.length > 0 && size === null) ? (
        <></>
      ) : (
        <>
          <div className="acc_line"></div>
          <div className="merchandisekit_container">
            {/* <img
              src={cart === true ? removeCartIcon : addCartIcon}
              className="mer_cart"
              onClick={() => {
                onCart(
                  item?.Name,
                  price || item?.Price,
                  productCode || item?.ProductCode,
                  item?.Catogery,
                  !cart,
                  counter,
                  color || item?.Color,
                  personalizeText || item?.PersonalizeText || "",
                  mrp || item?.MRP,
                  discount,
                  item?.Images[0],
                  size || item?.Size
                );
                setCart(!cart);
                updateCounter(!cart === false ? 1 : counter);
              }}
            ></img> */}

            {/* {item?.Variants?.length === 0 && item?.InventoryCount === 0 ? (
          <>
            <OutOfStock />
          </>
        ) : item?.Variants?.length > 0 && inventoryCount == 0 ? (
          <>
            <OutOfStock />
          </>
        ) : item?.Variants?.length === 0 && item?.Price === 0 ? (
          <>
            <OutOfStock />
          </>
        ) : item?.Variants?.length > 0 && price === 0 ? (
          <>
            <OutOfStock />
          </>
        ) : ( */}
            <CartIcon />
            {/* )} */}

            <Carousel
              swipeScrollTolerance={30}
              preventMovementUntilSwipeScrollTolerance={true}
              {...CarouselProps}
              className="carousel_img"
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                const defStyle = {
                  marginLeft: "0.8rem",
                  color: "black",
                  cursor: "pointer",
                  height: "0.6rem",
                  width: "0.6rem",
                  backgroundColor: "#393534",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginBottom: "-0.4rem",
                };
                const style = isSelected
                  ? { ...defStyle, backgroundColor: "#FFE100" }
                  : { ...defStyle };
                return (
                  <span
                    style={style}
                    onClick={onClickHandler}
                    onKeyDown={onClickHandler}
                    value={index}
                    key={index}
                    role="button"
                    tabIndex={0}
                    aria-label={`${label} ${index + 1}`}
                  ></span>
                );
              }}
            >
              {item.Images.slice(0, 5)?.map((item, key) => (
                <img key={key} src={item} alt="Product Image" />
              ))}
            </Carousel>

            <div className="label_con">
              <div className="product_header_con">
                <div className="product_header boldFont">{item?.Name}</div>
                <div className="product_subheader mediumFont">
                  {item?.ProductCatogery}
                  <img
                    style={{
                      display: item?.Description === "" ? "none" : "block",
                    }}
                    className="mer_info_icon"
                    src={info}
                    onClick={() => handleInfoModal(item)}
                  />
                </div>
              </div>
              {item.InventoryCount || inventoryCount ? <PriceLabel /> : null}
            </div>

            <div className="label_con_">
              {item && hasSize == false && parentHasSize && (
                <div className="product_details">
                  <div className="product_details_header boldFont">Size</div>
                  <Grid className="product_size_con" container>
                    {item?.Variants.map(
                      (r, index) =>
                        r?.Size && (
                          <Grid
                            item
                            key={index}
                            onClick={() => {
                              setChooseSize(index);
                              setColor(r?.Color);
                              setMrp(r?.MRP);
                              setPrice(r?.Price);
                              setDiscount(r?.DiscountPercentage);
                              setSize(r?.Size);
                              setProductCode(r?.ProductCode);
                              setPersonalizeText(r?.PersonalizeText);
                              onSizeChange(r?.ProductCode);
                              setMaxQuantity(r?.Quntity);
                            }}
                            className={
                              r?.Quntity !== 0 &&
                              r?.InventoryCount !== 0 &&
                              r?.Price !== "0" &&
                              r?.Price !== ""
                                ? "product_size boldFont"
                                : "product_size product_size_diagonal boldFont"
                            }
                            style={{
                              backgroundColor:
                                index === chooseSize &&
                                r?.Quntity !== 0 &&
                                r?.InventoryCount !== 0 &&
                                r?.Price !== "0" &&
                                r?.Price !== "" &&
                                `#FFE100`,
                              color:
                                index === chooseSize &&
                                r?.Quntity !== 0 &&
                                r?.InventoryCount !== 0 &&
                                r?.Price !== "0" &&
                                r?.Price !== ""
                                  ? `#2D3E6A`
                                  : `#CFCFCF`,
                              pointerEvents:
                                r?.Price === "0" ||
                                r?.InventoryCount === 0 ||
                                r?.Quntity === 0 ||
                                r?.Price === ""
                                  ? "none"
                                  : "auto",
                            }}
                          >
                            {r?.Size}
                          </Grid>
                        )
                    )}
                  </Grid>
                </div>
              )}

              <div className="flexbox_container">
                {item?.ColorImageUrl && (
                  <div className="flexbox">
                    <div className="product_details_header boldFont">Color</div>
                    <div className="product_size_con">
                      <img
                        src={item.ColorImageUrl}
                        className="product_color_img"
                        alt="img"
                      />

                      {/* <div
              className="product_color"
              style={{ border: 5 === 5 && 0.0625rem solid #707070 }}
              >
              <span style={{ backgroundColor: "#100e09" }}>
              <div
              className="product_color"
              style={{ border: 5 === 6 && 0.0625rem solid #707070 }}
              >
              <span style={{ backgroundColor: "#FF0000" }}>

              <div
              className="product_color"
              style={{ border: 5 === 6 && 0.0625rem solid #707070 }}
              >
              <span style={{ backgroundColor: "#004BFF" }}>

              <div
              className="product_color"
              style={{ border: 5 === 6 && 0.0625rem solid #707070 }}
              >
              <span style={{ backgroundColor: "#00FF33" }}>

              <div
              className="product_color"
              style={{ border: 5 === 6 && 0.0625rem solid #707070 }}
              >
              <span style={{ backgroundColor: "#FFA216" }}>
              */}
                    </div>
                  </div>
                )}

                <div className="flexbox">
                  <div className="product_details_header boldFont">
                    Quantity
                  </div>
                  <div
                    className="counter_con"
                    style={{ pointerEvents: cart === true && "none" }}
                  >
                    <img
                      src={minus}
                      className="counter_img"
                      onClick={() =>
                        handleDecrement(
                          productCode || item?.ProductCode,
                          price || item?.Price,
                          mrp || item?.MRP
                        )
                      }
                    ></img>
                    <div className="counter_label">{counter}</div>
                    <img
                      src={plus}
                      className="counter_img"
                      onClick={() =>
                        handleIncrement(
                          productCode || item?.ProductCode,
                          price || item?.Price,
                          mrp || item?.MRP,
                          maxQuantity || item?.Quntity
                        )
                      }
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MerchandiseKit;
